import {isJustEat} from '~/shared/config';

const translationKeysConfig = {
  tenbis: {
    default: {
      title: '10bis_tenbis_orders_restaurants_delivery_of_food_from_restaurants_pickup_10bis_card',
      description: '10bis_is_the_ideal_website_for_you_to_order_meals_from_restaurants_you_can_find_information_about_delivery_from_a_wide_variety_of_restaurants_all_over_the_country_delivery_menus_special_offers_and_much_more',
      keywords: 'kosher_restaurants_kosher_site_kasher_delivery_food_delivery_meal_delivery_10bis_tenbis_restaurant_delivery_delivery_in_tel_aviv_delivery_people_from_restaurants_night_time_eating',
    },
    cityPageTranslatedCityPrefixedCuisine: {
      title: 'xxx_food_xxx_xxx_deliveries_xxx_brandName',
      description: 'brandName_brings_best_xxx_food_xxx',
    },
    cityPageTranslatedCityUnPrefixedCuisine: {
      title: 'xxx_xxx_xxx_delivers_xxx_brandName',
      description: 'brandName_brings_best_food_xxx',
    },
    cityPageTranslatedCityNoCuisine: {
      title: 'deliveries_xxx_food_deliveries_xxx_10bis',
      description: 'brandName_brings_best_food_xxx',
    },
    newRestaurants: {
      title: 'new_restaurants_on_brandName',
      description: 'brandName_new_restaurants',
    },
    discountCoupon: {
      title: 'brandName_restaurants_with_coupons',
      description: 'in_this_site_you_can_order_food_with_discount_from_many_restaurants_you_can_find_a_list_of_restaurants_with_discount_and_many_other_types_of_restaurants',
    },
    fastDelivery: {
      title: 'brandName_restaurants_with_fast_delivery',
      description: 'in_this_site_you_can_order_food_with_fast_delivery_from_many_restaurants_you_can_find_a_list_of_restaurants_with_fast_delivery_and_many_other_types_of_restaurants',
    },
    isKosher: {
      title: 'brandName_restaurants_with_kosher',
      description: 'in_this_site_you_can_order_kosher_food_from_many_restaurants_you_can_find_a_list_of_kosher_restaurants_and_many_other_types_of_restaurants',
    },
    isVegan: {
      title: 'brandName_restaurants_vegan',
      description: 'in_this_site_you_can_order_vegan_food_from_many_restaurants_you_can_find_a_list_of_vegan_restaurants_and_many_other_types_of_restaurants',
    },
    isGlutenFree: {
      title: 'brandName_restaurants_gluten_free',
      description: 'in_this_site_you_can_order_gluten_free_food_from_many_restaurants_you_can_find_a_list_of_gluten_free_restaurants_and_many_other_types_of_restaurants',
    },
    resListNoFilter: {
      title: 'brandName_restaurants_delivery_pickup',
      description: 'brandName_best_site_for_ordering',
    },
    menuPageDeliveryRegular: {
      title: 'delivery_menu_order_delivery_xxx_xxx_brandName_xxx_xxx',
      description: 'xxx_xxx_order_online_from_your_favourite_restaurants',
    },
    menuPagePickupRegular: {
      title: 'pickup_menu_order_pickup_xxx_xxx_brandName_xxx_xxx',
      description: 'xxx_xxx_order_online_from_favourite_local_restaurants',
    },
    menuPageSittingRegular: {
      title: 'dine_in_menu_dine_in_xxx_xxx_brandName_xxx_xxx',
      description: 'xxx_xxx_dine_in_favourite_restaurants',
    },
    menuPageDeliveryStores: {
      title: 'delivery_menu_order_delivery_from_xxx_xxx_brandName_xxx_xxx',
      description: 'xxx_xxx_order_online_from_your_favourite_restaurants',
    },
    menuPagePickupStore: {
      title: 'pickup_menu_order_pickup_from_xxx_xxx_brandName_xxx_xxx',
      description: 'xxx_xxx_order_online_from_your_favourite_restaurants',
    },
    menuPageSittingStore: {
      title: 'dine_in_menu_dine_in_at_xxx_xxx_brandName_xxx_xxx',
      description: 'xxx_xxx_order_online_from_your_favourite_restaurants',
    },
    groupPageCustomizedDescription: {
      title: 'xxx_delivery_and_pickup_brandName',
      description: 'xxx_xxx_delivery_and_pickup_brandName',
      keywords: 'delivery_xxx_delivery_from_xxx_brandName_xxx',
    },
    groupPageDefault: {
      title: 'xxx_delivery_and_pickup_brandName',
      description: 'order_online_from_xxx_restaurants_now_via_brandName',
      keywords: 'delivery_xxx_delivery_from_xxx_brandName_xxx',
    },
  },
  justEat: {
    default: {
      title: 'just_eat_seo_title_default',
      description: 'just_eat_seo_description_default',
      keywords: 'just_eat_seo_keywords_default',
    },
    cityPageTranslatedCityPrefixedCuisine: {
      title: 'xxx_food_xxx_xxx_deliveries_xxx_brandName',
      description: 'brandName_brings_best_xxx_food_xxx',
    },
    cityPageTranslatedCityUnPrefixedCuisine: {
      title: 'xxx_xxx_xxx_delivers_xxx_brandName',
      description: 'feel_like_xxx_in_xxx_browse_menus',
    },
    cityPageTranslatedCityNoCuisine: {
      title: 'deliveries_xxx_food_deliveries_xxx_10bis',
      description: 'feel_like_xxx_in_xxx_browse_menus',
    },
    newRestaurants: {
      title: 'new_restaurants_on_brandName',
      description: 'just_eat_seo_new_restaurants_filter_description',
    },
    discountCoupon: {
      title: 'brandName_restaurants_with_coupons',
      description: 'just_eat_seo_discounts_filter_description',
    },
    fastDelivery: {
      title: 'brandName_restaurants_with_fast_delivery',
      description: 'just_eat_seo_fast_delivery_filter_description',
    },
    isKosher: {
      title: 'brandName_restaurants_with_kosher',
      description: 'in_this_site_you_can_order_kosher_food_from_many_restaurants_you_can_find_a_list_of_kosher_restaurants_and_many_other_types_of_restaurants',
    },
    isVegan: {
      title: 'brandName_restaurants_vegan',
      description: 'just_eat_seo_vegan_filter_description',
    },
    isGlutenFree: {
      title: 'brandName_restaurants_gluten_free',
      description: 'just_eat_seo_gluten_free_filter_description',
    },
    resListNoFilter: {
      title: 'just_eat_seo_title_default',
      description: 'when_you_feel_like_eating_something_good_brandName_is_here',
    },
    menuPageDeliveryRegular: {
      title: 'brandName_delivery_menu_order_delivery_xxx_xxx_brandName',
      description: 'craving_xxx_in_xxx_get_your_favourites',
    },
    menuPagePickupRegular: {
      title: 'brandName_pickup_menu_order_pickup_xxx_xxx_brandName_xxx_xxx',
      description: 'on_the_go_xxx_order_pickup',
    },
    menuPageSittingRegular: {
      title: 'brandName_dine_in_menu_dine_in_xxx_xxx_brandName_xxx_xxx',
      description: 'xxx_xxx_dine_in_favourite_restaurants',
    },
    menuPageDeliveryStores: {
      title: 'brandName_delivery_menu_order_delivery_xxx_xxx_brandName_store',
      description: 'craving_xxx_in_xxx_get_your_favourites',
    },
    menuPagePickupStore: {
      title: 'brandName_pickup_menu_order_pickup_xxx_xxx_brandName_xxx_xxx_store',
      description: 'on_the_go_xxx_order_pickup',
    },
    menuPageSittingStore: {
      title: 'xxx_xxx_delivery_pickup_brandName',
      description: 'xxx_xxx_dine_in_favourite_restaurants',
    },
    groupPageCustomizedDescription: {
      title: 'xxx_delivery_and_pickup_brandName',
      description: 'xxx_xxx_delivery_and_pickup_brandName',
      keywords: 'just_eat_seo_groups_meta_keywords',
    },
    groupPageDefault: {
      title: 'xxx_delivery_and_pickup_brandName',
      description: 'love_xxx_find_the_branch',
      keywords: 'just_eat_seo_groups_meta_keywords',
    },
  },
};

const getTranslationKeysConfig = () => translationKeysConfig[isJustEat ? 'justEat' : 'tenbis'];

export default getTranslationKeysConfig;
